import React from 'react';
import styles from './WhatWillYouGetBlock.module.css';
export default function WhatWillYouGetBlock() {
  return (
    <section id="1" className={styles.container}>
      <div className={styles.title}>💚 Що ти отримаєш?</div>
      <ul className={styles.list}>
        <li>Реальні результати вже за тиждень</li>
        <li>Зменшення об’ємів тіла </li>
        <li>Покращення самопочуття </li>
        <li>Більше енергії та легкості щодня</li>
        <li>Меню на кожен день</li>
        <li>Збалансований раціон без жорстких дієт</li>
        <li>Прості та смачні рецепти</li>
        <li>Підтримку та мотивацію</li>
        <li>Закрита спільнота учасниць</li>
        <li>Поради від фахівця нутриціолога</li>
      </ul>
    </section>
  );
}
